import { lazy, Suspense } from 'react';

import { RouteFallback } from '../../ui/RouteFallback';

const LoginPage = lazy(() => import('../../pages/Login'));

export const authRoutes = [
  {
    path: 'login',
    element: (
      <Suspense fallback={<RouteFallback />}>
        <LoginPage />
      </Suspense>
    ),
  },
];
